import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        cartProducts: [],
        courses: [],
        loggedUser: {},
        cartUpdate: {}
    },
    getters: {
        cartProducts: state => {
            return state.cartProducts
        },
        getLoggedUser: state => {
            return state.loggedUser
        },
        getCartUpdate: state => {
          return state.cartUpdate
        }
    },
    mutations: {
        ADD_CART_LOCAL: (state, product) => {
            state.cartProducts.push(product)
            localStorage.setItem('pt_vp', JSON.stringify(state.cartProducts))
        },

        SET_CART_PRODUCTS: (state, products) => {
            state.cartProducts = []
            state.cartProducts = products
        },

        ADD_COURSE_LOCAL: (state, course) => {
            this.state.courses.push(course);
            localStorage.setItem('pt_khoahoc', JSON.stringify(state.courses));
        },

        SET_COURSE_LOCAL: (state, courses) => {
            state.courses = []
            state.courses = courses
        },

        UPDATE_CART: (state => {
            state.cartUpdate = {};
        })
    },
    actions: {
      updateCart({commit}, task) {
        commit('UPDATE_CART', task)
      }
    }
})



// WEBPACK FOOTER //
// ./src/store.js